import { findAll, isUnattached, setAttached } from "./dom";

const csrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute("content") : "";
};

const onInput = (event) => {
  const form = event.target.closest("form");
  if (!form) return;

  const formData = new FormData(form);

  fetch(form.action, {
    method: form.method || "POST",
    body: formData,
    headers: {
      "X-CSRF-Token": csrfToken(),
      "Accept": "text/javascript"
    },
    credentials: "same-origin"
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
      return response.text();
    })
    .then((script) => {
      const el = document.createElement("script");
      el.text = script;
      document.head.appendChild(el).parentNode.removeChild(el);
    })
    .catch((error) => console.error("Autoupload error:", error));
};

export default () =>
  findAll(document, "form[data-gk-autoupload]")
    .filter((element) => isUnattached("autoupload", element))
    .map((element) => setAttached("autoupload", element))
    .forEach((element) =>
      element
        .querySelector("input[type=file]")
        .addEventListener("input", onInput)
    );
